import { Reveal } from "@/components/site/Reveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Μπορώ να ενημερώσω το περιεχόμενο του βίντεο μετά την παράδοση;",
    a: (
      <>
        Ναι. Συνδέετε το προϊόν σε υπολογιστή μέσω USB και αντικαθιστάτε το
        αρχείο βίντεο όποτε χρειάζεται, χωρίς κόστος και χωρίς τεχνικές
        γνώσεις.
      </>
    ),
  },
  {
    q: "Πόση χωρητικότητα έχει η συσκευή;",
    a: (
      <>
        Κάθε προϊόν προσαρμόζεται στις ανάγκες σας. Η χωρητικότητα εξαρτάται
        από την ανάλυση και τη διάρκεια του βίντεο που θέλετε. Σε κάθε
        περίπτωση, σχεδιάζουμε τη λύση στα μέτρα σας ώστε να χωράει ακριβώς
        αυτό που χρειάζεστε.
      </>
    ),
  },
  {
    q: "Πόση είναι η διάρκεια της μπαταρίας;",
    a: (
      <>
        Η διάρκεια αναπαραγωγής φτάνει περίπου τα 60 λεπτά συνεχόμενου
        βίντεο. Η μπαταρία φορτίζει πλήρως μέσω USB σε λίγες ώρες και μπορεί
        να επαναφορτιστεί εκατοντάδες φορές.
      </>
    ),
  },
  {
    q: "Μπορούν τα προϊόντα να γίνουν custom με βάση τις ανάγκες μου;",
    a: (
      <>
        Απόλυτα. Προσαρμόζουμε τον σχεδιασμό, τα υλικά, το μέγεθος οθόνης και
        το branding σύμφωνα με τις προδιαγραφές σας. Εκτός από τα έτοιμα
        προϊόντα, δημιουργούμε και εντελώς custom λύσεις από το μηδέν.{" "}
        <a href="#contact" className="font-semibold text-brand-600 underline">
          Επικοινωνήστε μαζί μας
        </a>{" "}
        για να σχεδιάσουμε μαζί.
      </>
    ),
  },
  {
    q: "Ποια είναι η ελάχιστη παραγγελία;",
    a: (
      <>
        Η ελάχιστη ποσότητα εξαρτάται από τον τύπο προϊόντος και τις
        προδιαγραφές που επιλέγετε. Χρησιμοποιήστε{" "}
        <a href="/calculator" className="font-semibold text-brand-600 underline">
          τον υπολογιστή κόστους μας
        </a>{" "}
        για να δείτε αναλυτικά τις επιλογές και τις τιμές ανά ποσότητα.
      </>
    ),
  },
  {
    q: "Πόσο χρόνο χρειάζεται η παραγωγή και η παράδοση;",
    a: (
      <>
        Ο μέσος χρόνος παραγωγής είναι 15 με 20 εργάσιμες ημέρες από την
        έγκριση του σχεδιασμού. Για επείγουσες ανάγκες, προσφέρουμε express
        παραγωγή με μειωμένο χρόνο παράδοσης.
      </>
    ),
  },
  {
    q: "Τι ανάλυση έχει η οθόνη;",
    a: (
      <>
        Προσφέρουμε οθόνες σε μεγέθη από 2.4 έως 10 ίντσες, με ανάλυση HD
        (720p) ή Full HD (1080p) ανάλογα με το μέγεθος. Η εικόνα είναι ζωηρή
        και καθαρή, ιδανική για παρουσιάσεις και brand content.
      </>
    ),
  },
  {
    q: "Πώς μπορώ να ξεκινήσω μια παραγγελία;",
    a: (
      <>
        Συμπληρώστε τη{" "}
        <a href="#contact" className="font-semibold text-brand-600 underline">
          φόρμα επικοινωνίας
        </a>{" "}
        ή στείλτε μας email. Θα σας καλέσουμε για να καταλάβουμε τις ανάγκες
        σας, θα σχεδιάσουμε μαζί τη λύση και θα σας στείλουμε δείγμα πριν
        προχωρήσετε στην τελική παραγωγή.
      </>
    ),
  },
];

export const Faq = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative scroll-mt-24 bg-white py-24 sm:py-36"
    >
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs font-semibold uppercase tracking-[0.3em] text-brand-600">
              · ΑΠΟΡΙΕΣ
            </span>
            <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-ink sm:text-5xl">
              Συχνές Ερωτήσεις
            </h2>
            <p className="mt-5 max-w-xs text-base text-muted-foreground">
              Ό,τι χρειάζεται να ξέρεις για την VideoActive πριν ξεκινήσεις.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.08}>
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-border"
                >
                  <AccordionTrigger className="py-6 text-left font-display text-lg font-semibold text-ink hover:no-underline data-[state=open]:text-brand-600 sm:text-xl">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base leading-relaxed text-ink/70">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
